import { useEffect, useRef } from "react";
import { saveLessonProgress } from "@/lib/api";

/**
 * Persists current slide index for the logged-in student (debounced).
 * Backend must implement POST …/user/studentcourse/lesson_progress (see docs).
 */
export function useLessonProgress(
  courseId: number,
  lessonId: number,
  slideIndex: number,
  totalSlides: number,
  options?: { enabled?: boolean }
): void {
  const enabled = options?.enabled !== false;
  const lastSent = useRef<{ i: number; t: number } | null>(null);

  useEffect(() => {
    if (!enabled || !courseId || !lessonId || totalSlides <= 0) return;

    const t = window.setTimeout(() => {
      const prev = lastSent.current;
      if (prev && prev.i === slideIndex && Date.now() - prev.t < 500) return;
      lastSent.current = { i: slideIndex, t: Date.now() };
      void saveLessonProgress(courseId, lessonId, {
        current_slide_index: slideIndex,
        total_slides: totalSlides,
      });
    }, 500);

    return () => clearTimeout(t);
  }, [enabled, courseId, lessonId, slideIndex, totalSlides]);
}
